import AppConfigService from '../services/AppConfigService'
import { isNullOrUndefined } from '../utils/common'

export default class HotjarInitializer {
  constructor () {
    return this.init()
  }

  async init () {
    const hotjarConfig = await AppConfigService.getConfigValue('hotjar')
    if (!hotjarConfig || !hotjarConfig.enabled || isNullOrUndefined(hotjarConfig.hjid)) return
    let hjsv = hotjarConfig || 6;
    /* eslint-disable */
    (function(h,o,t,j,a,r){
        h.hj=h.hj||function(){(h.hj.q=h.hj.q||[]).push(arguments)};
        h._hjSettings={hjid:hotjarConfig.hjid,hjsv:hjsv};
        a=o.getElementsByTagName('head')[0];
        r=o.createElement('script');r.async=1;
        r.src=t+h._hjSettings.hjid+j+h._hjSettings.hjsv;
        a.appendChild(r);
    })(window,document,'https://static.hotjar.com/c/hotjar-','.js?sv=')
  }
}
